import useFeatureSettingsUpdate from './useFeatureSettingsUpdate';

export default function useTimeOffReportSettingsUpdate() {
  return useFeatureSettingsUpdate('timeOffReport');
}
